// packages/app-sdk/src/events.ts
import type { z } from 'zod';
import type { EmitDef } from './manifest.js';

export interface EventDef<S extends z.ZodTypeAny = z.ZodTypeAny> {
  schema: S;
  version?: number;
  journal: { label: string; importance: 'low' | 'normal' | 'high' } | false;
  realtime?: boolean;
  classAll?: boolean;
}

/** Identité qui préserve les clés littérales (types d'événement) du générique `const`. */
export function defineEvents<const M extends Record<string, EventDef>>(events: M): M {
  return events;
}

/** Transforme le catalogue déclaratif d'une app en la forme attendue par `AppManifest.events.emits`. */
export function emitsOf<M extends Record<string, EventDef>>(events: M): EmitDef[] {
  return Object.entries(events).map(([type, def]) => ({
    type,
    version: def.version ?? 1,
    journal: def.journal,
    realtime: def.realtime ?? true,
    classAll: def.classAll ?? false,
  }));
}

export interface ForeignEventDef<S extends z.ZodTypeAny = z.ZodTypeAny> {
  readonly foreign: true;
  readonly type: string;
  readonly schema: S;
}

/** Contrat typé sur l'événement d'une AUTRE app, sans jamais importer cette app. */
export function foreign<S extends z.ZodTypeAny>(type: string, schema: S): ForeignEventDef<S> {
  return { foreign: true, type, schema };
}
